<template>
  <div class="statistics-other">
    <div class="title">其他统计</div>
    <div class="other-template" :key="data.name" v-for="data in datas" @click="goDetail(data.name)">
      <img :src="data.imgUrl" alt />
      <span v-text="data.name"></span>
      <i class="el-icon-arrow-right"></i>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: [
        {
          imgUrl: require("@/assets/dataQuery/dp-ld-sy8.png"),
          name: "党员信息统计"
        },
        {
          imgUrl: require("@/assets/dataQuery/dp-ld-sy9.png"),
          name: "资料上传统计"
        },
        {
          imgUrl: require("@/assets/dataQuery/dp-ld-sy10.png"),
          name: "三会一课统计"
        },
        {
          imgUrl: require("@/assets/dataQuery/dp-ld-sy11.png"),
          name: "办事服务统计"
        },
        // {
        //   imgUrl: require("@/assets/dataQuery/dp-ld-sy12.png"),
        //   name: "发送消息"
        // }
      ]
    };
  },
  name: "statisticsOther",
  props: {
    title: String
  },
  methods: {
    goDetail(name) {
      console.log(name);
      switch (name) {
        case "党员信息统计":
          this.$router.push({
            path: "dataQuery/partymsg",
            query: { title: name }
          });
          break;
        case '资料上传统计':
          this.$router.push({
            path: "dataQuery/dataupload",
            query: { title: name }
          });
          break;
        case "三会一课统计":
          this.$router.push({
            path: "dataQuery/threeclass",
            query: { title: name }
          });
          break;
        case "办事服务统计":
          this.$router.push({
            path: "dataQuery/dothings",
            query: { title: name }
          });

          break;
        case "发送消息":
          this.$router.push({
            path: "dataQuery/sendmsg",
            query: { title: name }
          });

          break;

        default:
          break;
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.statistics-other {
  .other-template {
    i {
      margin-left: auto;
      margin-right: 0.2rem;
    }
    img {
      width: 0.33rem;
      height: 0.33rem;
      margin: 0 0.2rem;
    }
    margin-top: 0.2rem;
    display: flex;
    align-items: center;
    box-shadow: 0px 0.04rem 0.16rem 0px rgba(0, 0, 0, 0.08);
    border-radius: 0.24rem;
  }
  .title {
    font-weight: bold;
  }
  background: #fff;
  padding: 0.2rem;
  font-size: 0.3rem;
  line-height: 3;
}
</style>